import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAdminUserState from './admin-user.reducer';
import { AdminUserEffects } from './admin-user.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromAdminUserState.adminUserFeatureKey,
			fromAdminUserState.reducer
		),
		EffectsModule.forFeature([AdminUserEffects]),
	],
})
export class AdminUserStateModule {}
